import { componentMap as formComponentMap } from '@cainiaofe/cn-ui';
import {
  executeObjectExpr,
  getItem as getCommonItem,
  getRealizeValue,
  getRunTimeBizComponent,
} from '../../util/util';
import './index.scss';
import {
  __dataSource__,
  __filterValue__,
  __formValue__,
} from '@/common/util/expr-const';
import { componentMap as validatorComponentMap } from '@/common/manager/validator';
import { ValidatorPosition } from '@/common/manager/position/validator-position';

import { config as ratingConfig } from './rating/view';
import { config as cnArraySubAreaCardConfig } from './cn-array-sub-area-card/view';
import { config as cnArrayTableConfig } from './cn-array-table/view';
import { config as composeConfig } from './compose/view';
import { config as addressSelectConfig } from './address-select/view';
import { config as arrayTableOptButtonConfig } from './array-table-opt-button/view';
import { config as inputConfig } from './input/view';
import { config as cnBatchInputConfig } from './cn-batch-input/view';
import { config as timePickerConfig } from './time-picker/view';
import { config as rangeTimePickerConfig } from './range-time-picker/view';
import { config as textAreaConfig } from './text-area/view';
import { config as switchConfig } from './switch/view';
import { config as timeLineConfig } from './timeline/view';
import { config as transferConfig } from './transfer/view';
import { config as treeSelectConfig } from './tree-select/view';
import { config as uploadConfig } from './upload/view';
import { config as autoCompleteConfig } from './auto-complete/view';
import { config as cascaderSelectConfig } from './cascader-select/view';
import { config as checkboxGroupConfig } from './checkbox-group/view';
import { config as cnArrayTableIndexConfig } from './cn-array-table-index/view';
import { config as cnCardConfig } from './cn-card/view';
import { config as cnCardSubCardConfig } from './cn-card-sub-card/view';
import { config as cnFormStepItemConfig } from './cn-form-step-item/view';
import { config as cnFormTabItemConfig } from './cn-form-tab-item/view';
import { config as datePickerConfig } from './date-picker/view';
import { config as departmentSelectConfig } from './department-select/view';
import { config as employeeSelectConfig } from './employee-select/view';
import { config as formItemSlotConfig } from './form-item-slot/view';
import { config as imageViewerConfig } from './image-viewer/view';
import { config as messageConfig } from './message/view';
import { config as numberPickerConfig } from './number-picker/view';
import { config as ossImageUploadConfig } from './oss-image-upload/view';
import { config as radioGroupConfig } from './radio-group/view';
import { config as rangeConfig } from './range/view';
import { config as rangeNumberPickerConfig } from './range-number-picker/view';
import { config as rangePickerConfig } from './range-picker/view';
import { config as readOnlyConfig } from './read-only/view';
import { config as selectConfig } from './select/view';

export const componentMap = {
  Input: inputConfig,
  CnBatchInput: cnBatchInputConfig,
  CnArrayTableIndex: cnArrayTableIndexConfig,
  NumberPicker: numberPickerConfig,
  RangeNumberPicker: rangeNumberPickerConfig,
  Select: selectConfig,
  RadioGroup: radioGroupConfig,
  CheckboxGroup: checkboxGroupConfig,
  DatePicker: datePickerConfig,
  TimePicker: timePickerConfig,
  RangePicker: rangePickerConfig,
  RangeTimePicker: rangeTimePickerConfig,
  EmployeeSelect: employeeSelectConfig,
  AddressSelect: addressSelectConfig,
  DepartmentSelect: departmentSelectConfig,
  TextArea: textAreaConfig,
  Switch: switchConfig,
  CnCard: cnCardConfig,
  CnCardSubCard: cnCardSubCardConfig,
  Message: messageConfig,
  Upload: uploadConfig,
  OSSImageUpload: ossImageUploadConfig,
  CnArrayTable: cnArrayTableConfig,
  ArrayTableOptButton: arrayTableOptButtonConfig,
  TreeSelect: treeSelectConfig,
  CascaderSelect: cascaderSelectConfig,
  ImageViewer: imageViewerConfig,
  Rating: ratingConfig,
  Range: rangeConfig,
  CnFormStepItem: cnFormStepItemConfig,
  Compose: composeConfig,
  AutoComplete: autoCompleteConfig,
  CnArraySubAreaCard: cnArraySubAreaCardConfig,
  CnFormTabItem: cnFormTabItemConfig,
  Transfer: transferConfig,
  FormItemSlot: formItemSlotConfig,
  TimeLine: timeLineConfig,
  ReadOnly: readOnlyConfig,
};

const formItemComponentMap = {};
Object.keys(componentMap).forEach((name) => {
  const item = componentMap[name];
  if (item && item.formComponent) {
    formItemComponentMap[name] = item.formComponent;
  }
});

// export function getRunTimeBizComponentListByPosition(config) {
//   const { position } = config;
//   const result = [];
//   const bizComponentNameList = getBizComponentNameList();
//   bizComponentNameList.forEach((name) => {
//     const component = getItem(position, name);
//     if (component) {
//       const { title, value, label, componentName } = component;
//       const runTimeComponent = getRunTimeItem(componentName);
//       if(runTimeComponent){
//         result.push(runTimeComponent);
//       }
//     }
//   });
//   return result;
// }

export function getRunTimeItem(componentName) {
  let result;
  if (componentName) {
    result = componentMap[componentName];
    if (!result) {
      result = getRunTimeBizComponent(componentName);
    }
  }
  return result;
}

export function getFormExtraComponents(usedComponentList = []) {
  const result = { ...formItemComponentMap };
  usedComponentList.forEach((name) => {
    if (!result[name] && !formComponentMap[name]) {
      const component = getRunTimeBizComponent(name);
      if (component && component.component) {
        result[name] = getRealizeValue(component.component);
      }
    }
  });
  return result;
}
export function transRulesToValidator(rules, config) {
  const { formValue, state, position, isInCnFilterPro } = config || {};

  const result = [];
  if (Array.isArray(rules) && rules.length > 0) {
    rules.forEach((item) => {
      const { name, active, options = {}, message, triggerType } = item;
      const isActive = executeObjectExpr(
        active,
        {
          [__formValue__]: formValue || {},
          [__filterValue__]: formValue || {},
          [__dataSource__]: state,
        },
        formValue || {},
        state,
      );
      if (isActive && name) {
        const action = getCommonItem(
          validatorComponentMap,
          position,
          name,
          'action',
        );
        let temp;
        if (action) {
          temp = action({
            validateItemConfig: item,
            position,
          });
        } else {
          temp = {
            ...options,
          };
          const { pattern } = options;
          if (pattern?.length > 2) {
            if (pattern.startsWith('/') && pattern.endsWith('/')) {
              temp.pattern = new RegExp(pattern.slice(1, -1));
            }
          }
          if (message) {
            temp.message = message;
          }
        }
        if (triggerType) {
          if (ValidatorPosition.filter === position) {
            if (temp) {
              temp.trigger = triggerType;
            }
          } else if (temp) {
            temp.triggerType = triggerType;
          }
        }
        if (ValidatorPosition.form === position) {
          if (isInCnFilterPro && name === 'custom') {
            const originalValidator = temp.validator;
            temp.validator = (value, _rules, context) => {
              const firstParam = {
                field: context?.field?.props?.name,
                message: _rules?.message,
              };
              const secondParam = value;
              let errorMsg;
              const thirdParam = (temMsg) => {
                if (temMsg) {
                  errorMsg = temMsg;
                }
              };
              const forthParam = context?.form?.values || {};
              const fifthParam = state;
              originalValidator(
                firstParam,
                secondParam,
                thirdParam,
                forthParam,
                fifthParam,
              );
              if (errorMsg) {
                return errorMsg;
              }
            };
          } else if (typeof temp?.validator === 'function') {
            const originalValidator = temp.validator;
            temp.validator = (value, _rules, context) => {
              return originalValidator(value, _rules, context, state);
            };
          }
        }
        if (ValidatorPosition.filter === position) {
          if (typeof temp?.validator === 'function') {
            const originalValidator = temp.validator;
            temp.validator = (rule, value, callback) => {
              originalValidator(rule, value, callback, formValue, state);
            };
          }
        }

        if (temp) {
          result.push(temp);
        }
      }
    });
  }
  return result;
}
